<div class="min-h-screen bg-[#eee] font-inter">
    <div class="max-w-7xl mx-auto py-3 px-2 md:px-3 md:p-5">
        <div class="grid grid-cols-12 gap-2">
            <div
                class="col-span-full h-fit md:col-span-8 md:ml-16 lg:ml-0 bg-white rounded-sm shadow-[0_0_8px_rgba(58,51,46,0.26)] p-5 mb-3">
                <router-outlet></router-outlet>
            </div>

            <div class="col-span-full h-fit md:col-span-4 lg:px-4">
                <div class="grid grid-col-12">
                    <div class="boxed bg-white rounded-sm shadow-[0_0_8px_rgba(58,51,46,0.26)] px-5 pt-5 pb-[6px] mb-3">
                        <div class="col-span-full space-y-4">
                            <div
                                class="bg-white border border-[#ddd] rounded-[4px] shadow-[0_1px_1px_rgba(0,0,0,0.05)]">
                                <div class="panel-body pt-[5px] pb-3 px-3">
                                    <span class="text-sm text-[#757575]">Search jobs by</span>

                                    <div class="flex justify-between mt-[5px] p-0">
                                        <input type="text" [(ngModel)]="searchKeyword" placeholder="Keywords"
                                            class="pl-1 py-2 w-3/4 text-sm text-gray-500 border border-[#ddd] rounded focus:border-[#ddd] focus:ring-1 focus:ring-[#66afe9] focus:outline-none" />
                                        <button (click)="onSearch()"
                                            class="bg-[#357E37] text-white py-2 rounded px-4 hover:bg-[#1e6207] grow ml-2">
                                            Go
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="bg-white border border-[#ddd] rounded-[4px] shadow-[0_1px_1px_rgba(0,0,0,0.05)]">
                               
                                <div class="bg-[#f5f5f5] border-b border-[#ddd] py-2">
                                    <h3 class="text-sm text-[#666666] font-bold ml-2">
                                        {{ sidebarHeader() }}
                                    </h3>
                                </div>
                                <div class="text-[#757575] m-0 pl-5">
                                    <ul
                                        class="py-4 pl-6 list-outside list-[square] space-y-[5px] [&_a:hover]:text-[#757575] [&_a:hover]:underline text-base">
                                        @for (item of sidebarData(); track item.title) {
                                           <li>
                                            <a class="cursor-pointer" [routerLink]="item.url">
                                                {{ item.title }}
                                            </a>
                                        </li>
                                        }
                                    </ul>
                                </div>
                                
                            </div>

                            <div class="grid grid-col-12">
                                @if (initStructureData()) {
                                <div
                                    class="bg-white border border-[#ddd] rounded-[4px] shadow-[0_1px_1px_rgba(0,0,0,0.05)]">
                                    <div class="bg-[#f5f5f5] border-b border-[#ddd] py-2">
                                        <h3 class="text-sm text-[#666666] font-bold ml-2">
                                            {{ initStructureData()?.header }}
                                        </h3>
                                    </div>

                                    <div class="text-[#757575] m-0 pl-5">
                                        <ul
                                            class="py-4 pl-6 list-outside list-[square] space-y-[5px] [&_a:hover]:text-[#757575] [&_a:hover]:underline text-sm">
                                            @for (item of initStructureData()?.data; track $index) {
                                            @if (item.type === "tip") {
                                            <li>
                                                <a class="cursor-pointer text-base" [routerLink]="item.url">
                                                    {{ item.title }}
                                                </a>
                                            </li>
                                            } @else if (item.type === "article") {
                                            <li class="space-y-1">
                                                <div (click)="toggleArticle(item)"
                                                    class="flex items-start gap-1 cursor-pointer group">
                                                    <span
                                                        class="text-base/8 font-medium text-[#757575] group-hover:text-[#2f64a3]">
                                                        {{ item.articleHeader }}
                                                    </span>
                                                </div>

                                                <div class="grid transition-[grid-template-rows] duration-300 ease-in-out"
                                                    [class.grid-rows-[1fr]]="item.collapsed"
                                                    [class.grid-rows-[0fr]]="!item.collapsed">
                                                    <ul class="space-y-2 overflow-hidden">
                                                        @for (
                                                        article of item.articleList;
                                                        track $index
                                                        ) {
                                                        <li class="flex items-start gap-1">
                                                            <span class="text-[#757575] font-light flex-shrink-1">{{
                                                                item.collapsed ? "↳ " : "." }}</span>
                                                            <a [routerLink]="[article.url]"
                                                                class="text-base/8 leading-tight text-[#757575] hover:underline hover:text-blue-500"
                                                                [innerHTML]="article?.title">
                                                            </a>
                                                        </li>
                                                        }
                                                    </ul>
                                                </div>
                                            </li>
                                            }
                                            }
                                        </ul>
                                    </div>
                                </div>
                                }
                            </div>
                            <!-- RMG বা ক্যাটাগরি মেনু বক্স -->
                            @if (categoryItems().length > 0) {
                            <div class="mb-4 overflow-hidden border border-gray-300 rounded shadow-sm bg-white">
                                <div class="bg-[#f5f5f5] px-4 py-2 border-b border-gray-300">
                                    <h3 class="text-[15px] font-bold text-[#525252] m-0 tracking-tight">
                                        {{ categoryHeader() }}
                                    </h3>
                                </div>
                                <!-- List Section -->
                                <div class="p-3 pl-7">
                                    <ul
                                        class="py-2 pl-0 list-none m-0 [&_a:hover]:text-[#525252] [&_a:hover]:underline">
                                        @for (item of categoryItems(); track $index) {
                                        <li class="flex items-start py-1 border-gray-50 last:border-0">
                                            <span class="mr-3 text-[#757575] text-[10px] mt-[6px] leading-none">■</span>
                                            <a [routerLink]="item.link"
                                                class="text-[14px] text-[#525252] no-underline transition-colors duration-200">
                                                {{ item.label }}
                                            </a>
                                        </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                            }
                            <div class="grid grid-col-12">
                                <!-- Google Ad 300x600 -->
                                @if (showGoogleAd1()) {
                                <div class="">
                                    <ins class="adsbygoogle inline-block w-75 h-[600px]"
                                        data-ad-client="ca-pub-5130888087776673" data-ad-slot="5095213945">
                                    </ins>
                                </div>
                                }
                                <!-- Wizards BD Ad 300x250 -->
                                @if (showWizardsAd()) {
                                <div class="single-promo w-75 h-64">
                                    <script type="text/javascript" data-cfasync="false"
                                        src="https://www.wizardsbd.com/payload/deliver.js?pzoneid=728&height=250&width=300&tld=bdjobs.com"></script>
                                </div>
                                }
                                <!-- Google Ad 160x600 -->
                                @if (showGoogleAd2()) {
                                <div class="w-1/2">
                                    <ins class="adsbygoogle inline-block w-5 h-[600px]"
                                        data-ad-client="ca-pub-5130888087776673" data-ad-slot="4170210744">
                                    </ins>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>